.inline {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  /* A token colour, not opacity: opacity over an unknown background can fall below 4.5:1 */
  color: var(--tuna-content-secondary);
}

/* Fixed at 56px whatever the state: never the snapshot's height (spec §8.1, §8.9 #3) */
.block {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  height: 56px;
  box-sizing: border-box;
  padding: 0 var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  overflow: hidden;
}

.icon {
  flex: none;
}

.text {
  flex: 1;
  min-width: 0;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
